/**
 * addLayersGate.ts
 * addLayers()の実行制御（旧watchFlgの代替）
 *
 * カウンター方式: requestAddLayers()でインクリメント、consumeAddLayersRequest()でリセット
 * ext側のupdateSelectedLayersではカウンターを触らないので、addLayersは走らない
 */

/**
 * addLayers()の実行をリクエスト（旧 watchFlg[mapName] = true）
 */
export function requestAddLayers(store: any, mapName: string): void {
  store.state.addLayersRequested[mapName]++
}

/**
 * addLayers()のリクエストを消費（旧 watchFlg[mapName] チェック + false）
 * @returns true: 実行すべき, false: スキップ
 */
export function consumeAddLayersRequest(store: any, mapName: string): boolean {
  if (store.state.addLayersRequested[mapName] > 0) {
    store.state.addLayersRequested[mapName] = 0
    return true
  }
  return false
}
